<template>
  <div class="threeDimensional">
    <div class="content">
      <ul class="ul">
        <li class="li" v-for="(item, index) in imgList" :key="index">
          <div class="img">
            <img :src="item.img" alt="" />
            <div class="layer">
              {{ item.desc }}
            </div>
          </div>
          <!-- <div class="name">
            {{ item.name }}
          </div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'threeDimensional',
  data() {
    return {
      imgList: [
        {
          img: require('./img/baimo.jpg'),
          name: '三维白膜',
          desc: '以区域建筑物数据为主，直观展示区域规划样貌，易于辨认，适用于大范围地图展示'
        },
        {
          img: require('./img/lanmo.jpg'),
          name: '三维蓝膜',
          desc: '以区域建筑物数据为主，直观展示区域规划样貌，易于辨认，适用于大范围地图展示'
        },
        {
          img: require('./img/jingmo.jpg'),
          name: '三维精膜',
          desc: '以区域建筑物数据为主，直观展示区域规划样貌，易于辨认，适用于大范围地图展示'
        },
        {
          img: require('./img/UE4.jpg'),
          name: '三维UE4',
          desc: '以区域建筑物数据为主，直观展示区域规划样貌，易于辨认，适用于大范围地图展示'
        },
        {
          img: require('./img/combination.jpg'),
          name: '白膜高精结合',
          desc: '以区域建筑物数据为主，直观展示区域规划样貌，易于辨认，适用于大范围地图展示'
        },
        {
          img: require('./img/BIM.jpg'),
          name: 'BIM',
          desc: '以区域建筑物数据为主，直观展示区域规划样貌，易于辨认，适用于大范围地图展示'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.threeDimensional {
  .content {
    width: 100%;
    min-height: 950px;
    background: #ffffff;
    // border: 1px solid #979797;
    margin: 0 auto;
    .ul {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      min-height: 850px;
      padding: 45px 240px 0 240px;
      justify-content: space-between;
      .li {
        margin-top: 45px;
        text-align: center;
        .img {
          width: 416px;
          height: 234px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .layer {
            position: absolute;
            left: 0;
            bottom: -165px;
            width: 100%;
            height: 165px;
            transition: 0.5s;
            background: rgba(0, 0, 0, 0.6);
            color: #fff;
            font-family: 'PingFang';
            font-size: 22px;
            line-height: 30px;
            box-sizing: border-box;
            padding: 23px 58px 0 39px;
            text-align: left;
          }
        }
        .name {
          margin-top: 18px;
          font-size: 26px;
          font-family: 'PingFang';
          font-weight: bold;
          color: #000000;
        }
        // &:hover {
        //   .img {
        //     .layer {
        //       bottom: 0;
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
